import { MsalAuthenticationTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../../authConfig";

// Sample app imports
import { Loading } from "../../components/Loading";
import { ErrorComponent } from "../../components/ErrorComponent";
import { GlobalContext } from "../../utils/GlobalContext";
import { CredentialsContext } from "./CredentialsContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ProtectedPage from "../../utils/ProtectedPage";
import { useContext, useEffect, useRef, useState } from "react";
import { APIReturnObject, NotificationQueue, Status } from "../../utils/Definitions";
import { ModalNotification } from "../../components/ModalNotification";



const FaxContent = () => {
    const navigate = useNavigate();
    const credentialsContext = useContext(CredentialsContext);
    const globalContext = useContext(GlobalContext);

    const [uploadedFile, setUploadedFile] = useState<File | null>(null);
    const [faxNumbers, setFaxNumbers] = useState("");
    const [validation, setValidation] = useState<{ valid: string[]; invalid: string[] }>({ valid: [], invalid: [] });

    const [pdfData, setPdfData] = useState<ArrayBuffer | null>(null);
    const [pdfBase64, setPdfBase64] = useState<string | null>(null);

    const [isSending, setIsSending] = useState(false);

    const [successModalActive, setSuccessModalActive] = useState<boolean>(false)

    const [faxQueue, setFaxQueue] = useState<NotificationQueue[]>([]);
    const [isLoadingQueue, setIsLoadingQueue] = useState(false);

    const [pageLoading, setPageLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    const [showAllHistory, setShowAllHistory] = useState(false);

    const fileInputRef = useRef<HTMLInputElement | null>(null);


    const sendFax = () => {

        if (!uploadedFile || !pdfBase64 || validation.valid.length === 0) {
            return;
        }

        setIsSending(true);

        globalContext.GetToken().then((token: any) => {

            const headers = new Headers();
            headers.append("Authorization", "Bearer " + token);
            headers.append("Content-Type", "application/json;charset=UTF-8");

            const body = JSON.stringify({
                pdf: pdfBase64, // base64 → auto binds to byte[]
                pdfname: uploadedFile.name,    
                phoneNumbers: validation.valid 
            });

            fetch(apiConfig.apiEndpoint + "/Credentials/SendFax", {
                method: "POST",
                headers: headers,
                body: body
            })
            .then(res => res.json())
            .then(
                (result: APIReturnObject) => {
                    if (result.status === Status.SUCCESS) {
                        setIsSending(false);

                        // Reset form
                        setUploadedFile(null);
                        setPdfData(null);
                        setPdfBase64(null);
                        setFaxNumbers("");
                        setValidation({ valid: [], invalid: [] });

                        //Reset the actual file input DOM value
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }

                        //success message
                        setSuccessModalActive(true);

                        UpdateQueue();
                    }
                    else if (result.status === Status.FAIL) {
                        globalContext.setNotificationModalMessage("Cannot send one or more Fax's. " + result.message);
                        globalContext.setNotificationModalActive(true);
                        setIsSending(false);
                    }
                    else if (result.status === Status.ERROR) {
                        globalContext.setErrorModalProps({ errorMessage: "ERROR: One or more Fax's failed to send. " + result.message, errorLocation: "/Credentials/SendFax" });
                        globalContext.setErrorModalActive(true);
                        setIsSending(false);
                    }
                },
                (error) => {
                    globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/SendFax" });
                    globalContext.setErrorModalActive(true);
                    setIsSending(false);
                }
            );
        });
    };




    const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    };


    const validateNumbers = () => {
        const cleaned = normalizeFaxInput(faxNumbers);

        const lines = cleaned
            .split("\n")
            .map(l => l.trim())
            .filter(l => l.length > 0);

        const valid: string[] = [];
        const invalid: string[] = [];

        lines.forEach(raw => {
            // Keep digits only
            let digits = raw.replace(/\D/g, "");

            // Accept leading 1 for US numbers
            if (digits.length === 11 && digits.startsWith("1")) {
                digits = digits.slice(1);
            }

            // Must be exactly 10 digits after normalization
            if (digits.length === 10) {
                valid.push(digits);
            } else {
                invalid.push(raw);
            }
        });

        setValidation({ valid, invalid });

        // Update UI to show normalized numbers
        setFaxNumbers(
            valid.join("\n") +
            (invalid.length ? "\n" + invalid.join("\n") : "")
        );
    };




    const normalizeFaxInput = (raw: string) => {
        if (!raw) return "";

        return raw
            // Turn commas, semicolons, and tabs into line breaks
            .replace(/[,;\t]+/g, "\n")

            // Normalize CRLF and extra spacing
            .replace(/\r/g, "")

            // Remove duplicate spaces
            .replace(/[ ]+/g, " ")

            // Trim each line
            .split("\n")
            .map(x => x.trim())
            .filter(x => x.length > 0)

            // Remove duplicates
            .filter((value, index, self) => self.indexOf(value) === index)

            // Join again
            .join("\n");
    };

    function SuccessModalClose() {

    }

    useEffect(() => {
        console.log("PDF:" + pdfBase64);

    }, [pdfBase64]);

    useEffect(() => {
        UpdateQueue();

    }, [showAllHistory]);

    function UpdateQueue() {
        setIsLoadingQueue(true);

        globalContext.GetToken().then((token: any) => {
            const headers = new Headers();
            headers.append("Authorization", "Bearer " + token);
            headers.append("Content-Type", "application/json;charset=UTF-8");

            const url = apiConfig.apiEndpoint + "/Credentials/GetFaxs?all=" + (showAllHistory == true);

            fetch(url, {
                method: "GET",
                headers: headers
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        setFaxQueue(result);
                        setIsLoadingQueue(false);
                        setPageLoading(false);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Credentials/GetFaxs" });
                        globalContext.setErrorModalActive(true);
                        setIsLoadingQueue(false);
                        setPageLoading(false);
                    }
                );
        });
    }


    useEffect(() => {
        const intervalId = setInterval(() => {

            UpdateQueue();

        }, (30 * 1000)); // 30 seconds

        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    });

    useEffect(() => {
        UpdateQueue();
    }, []);


    const formatPhoneNumber = (digits: string) => {
        const cleaned = digits.replace(/\D/g, ""); // Keep only numbers
        if (cleaned.length !== 10) return digits;   // Return as-is if not 10 digits
        const area = cleaned.slice(0, 3);
        const prefix = cleaned.slice(3, 6);
        const line = cleaned.slice(6, 10);
        return `(${area}) ${prefix}-${line}`;
    };

    const formatDateTime = (dateInput: string | Date | null) => {
        if (!dateInput) return "-";

        let date: Date;

        // If it's a string with no timezone, force UTC by appending "Z"
        if (typeof dateInput === "string" && !dateInput.endsWith("Z")) {
            date = new Date(dateInput + "Z");
        } else {
            date = new Date(dateInput);
        }

        return date.toLocaleString([], {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true
        });
    };


    const filteredQueue = faxQueue.filter(fax => {
        const dateStr = formatDateTime(fax.queuedOn);
        const fileStr = fax.message || "";
        const phoneStr = formatPhoneNumber(fax.phoneNumber);
        const statusStr = fax.sent ? `Sent on ${formatDateTime(fax.sentOn)}` : "Pending";

        const combined = `${dateStr} ${fileStr} ${phoneStr} ${statusStr}`.toLowerCase();
        return combined.includes(searchQuery.toLowerCase());
    });



    if (pageLoading) {
        return (
            <div className="w-full h-auto flex">
                <FontAwesomeIcon className="fill-current text-lacblue w-24 h-24 animate-spin m-auto" icon={solid('spinner')} />
            </div>
        )
        
    }
    else {
        return (
            <div className="w-full max-w-6xl mx-auto p-6 space-y-8">

                {/* Title */}
                <h1 className="text-3xl font-semibold tracking-tight">Mass Fax Sender</h1>

                {/* 3-Column Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                    {/* Upload PDF */}
                    <div className="border rounded-xl shadow-sm p-5 bg-white">
                        <h2 className="text-lg font-medium mb-3">Upload PDF to Send</h2>

                        <label
                            htmlFor="pdfUpload"
                            className="flex flex-col items-center justify-center h-40 border-2 border-dashed rounded-lg cursor-pointer hover:bg-gray-50"
                        >
                            <span className="text-gray-500">Drag PDF here or click</span>
                            <span className="text-blue-600 font-medium mt-2">Choose PDF</span>
                        </label>

                        <input
                            id="pdfUpload"
                            ref={fileInputRef}
                            type="file"
                            accept="application/pdf"
                            className="hidden"
                            onChange={async (e) => {
                                const file = e.target.files?.[0] || null;
                                setUploadedFile(file);

                                if (file) {
                                    const arrayBuf = await file.arrayBuffer();
                                    setPdfData(arrayBuf);
                                    setPdfBase64(arrayBufferToBase64(arrayBuf));
                                } else {
                                    setPdfData(null);
                                    setPdfBase64(null);
                                }
                            }}
                        />


                        {uploadedFile && (
                            <div className="mt-3 text-sm text-gray-700">
                                <strong>Selected:</strong> {uploadedFile.name}
                            </div>
                        )}
                    </div>

                    {/* Fax Numbers */}
                    <div className="border rounded-xl shadow-sm p-5 bg-white">
                        <h2 className="text-lg font-medium mb-3">Recipient Fax Numbers</h2>

                        <textarea
                            className="w-full h-32 border rounded-md p-2 text-sm"
                            placeholder="Paste fax numbers here, one per line..."
                            value={faxNumbers}
                            onPaste={(e) => {
                                e.preventDefault();
                                const pasted = e.clipboardData.getData("text");
                                const cleaned = normalizeFaxInput(pasted);
                                setFaxNumbers(prev => normalizeFaxInput(prev + "\n" + cleaned));
                            }}
                            onChange={(e) => setFaxNumbers(e.target.value)}
                        />


                        <button
                            onClick={validateNumbers}
                            className="mt-3 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 w-full"
                        >
                            Clean & Validate Numbers
                        </button>

                        <div className="mt-3 text-sm">
                            {validation.valid.length > 0 && (
                                <p className="text-green-700">✔ {validation.valid.length} valid numbers</p>
                            )}
                            {validation.invalid.length > 0 && (
                                <p className="text-red-700">✖ {validation.invalid.length} invalid numbers</p>
                            )}
                        </div>
                    </div>

                    {/* Send Fax */}
                    <div className="border rounded-xl shadow-sm p-5 bg-white">
                        <h2 className="text-lg font-medium mb-3">Send Fax</h2>

                        <div className="text-sm text-gray-700 space-y-1">
                            <p><strong>File:</strong> {uploadedFile ? uploadedFile.name : "None"}</p>
                            <p><strong>Recipients:</strong> {validation.valid.length}</p>
                        </div>

                        <button
                            onClick={sendFax}
                            disabled={!uploadedFile || validation.valid.length === 0 || isSending}
                            className={`mt-4 w-full py-2 px-4 rounded-md text-white ${!uploadedFile || validation.valid.length === 0 || isSending
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-lacgreen hover:bg-lacgreen-600"
                                }`}
                        >
                            {isSending ? "Sending..." : "Send Fax to All"}
                        </button>
                        
                    </div>
                </div>

                {/* Fax History */}
                <div className="border rounded-xl shadow-sm bg-white p-5">
                    <h2 className="text-lg font-medium mb-4 flex items-center justify-between">
                        <div className="flex items-center">
                            Fax History
                            {isLoadingQueue && (
                                <FontAwesomeIcon
                                    className="fill-current text-lacblue w-5 h-5 animate-spin ml-2"
                                    icon={solid('spinner')}
                                />
                            )}
                        </div>

                        {/* Toggle Switch */}
                        <div className="flex items-center space-x-2">
                            <span className="text-sm text-gray-600">Show all history</span>

                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={showAllHistory}
                                    onChange={(e) => {
                                        setShowAllHistory(e.target.checked);
                                    }}
                                    className="sr-only peer"
                                />
                                <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:ring-2 peer-focus:ring-blue-500
                peer-checked:bg-blue-600 transition-all after:content-[''] after:absolute after:left-1 after:top-1
                after:bg-white after:h-4 after:w-4 after:rounded-full after:transition-all
                peer-checked:after:translate-x-5">
                                </div>
                            </label>

                            <span className="text-sm text-gray-600"></span>
                        </div>
                    </h2>


                    <div className="flex items-center justify-between mb-3">
                        <input
                            className="border rounded-md p-2 text-sm w-full md:w-64 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                            placeholder="Search by date, file, number, or status..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>



                    <div className="overflow-x-auto">
                        <table className="w-full text-sm border">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="p-2 border">Date Queued</th>
                                    <th className="p-2 border">File</th>
                                    <th className="p-2 border">Fax Number</th>
                                    <th className="p-2 border">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredQueue.length === 0 && !isLoadingQueue && (
                                    <tr>
                                        <td colSpan={4} className="text-center p-4">No faxes found</td>
                                    </tr>
                                )}

                                {filteredQueue.map(fax => (
                                    <tr key={fax.notificationQueueId}>
                                        <td className="p-2 border">{formatDateTime(fax.queuedOn)}</td>
                                        <td className="p-2 border">{fax.message}</td>
                                        <td className="p-2 border">{formatPhoneNumber(fax.phoneNumber)}</td>
                                        <td className={`p-2 border ${fax.sent ? "text-green" : "text-yellow"}`}>
                                            {fax.sent ? `Sent on ${formatDateTime(fax.sentOn)}` : "Pending"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>


                        </table>
                    </div>
                </div>


                <ModalNotification Title={"Success!"} Body={"The Fax(s) have been succesfully queued."} Active={successModalActive} Icon={"Success"} setActive={setSuccessModalActive} OnModalClose={SuccessModalClose} />
            </div>
        );
    }
    
};


export function Fax() 
{

    const authRequest = {
        ...loginRequest
    };

    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
                <ProtectedPage RequiredRoles={['Fax']}>
                    <FaxContent />
                </ProtectedPage>
            </MsalAuthenticationTemplate>

            <UnauthenticatedTemplate>

            </UnauthenticatedTemplate>
        </>
    );
}